import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import { PenLine, Upload, Palette, CheckCircle2, Truck, ArrowRight } from "lucide-react";

const steps = [
  { icon: PenLine, title: "1. Tell us your idea", desc: "Bring a verse, a logo, a rough sketch — or ask us to design it for you." },
  { icon: Upload, title: "2. Upload or describe", desc: "Send us your file, or tell us the vibe. Colors, size, deadline — all optional." },
  { icon: Palette, title: "3. We create a proof", desc: "Within one business day, you'll get a proof of your shirt — no charge until you approve." },
  { icon: CheckCircle2, title: "4. You approve", desc: "Tweak the design, swap a color, adjust the size — as many revisions as you need." },
  { icon: Truck, title: "5. We print & ship", desc: "Printed, packed and shipped from the U.S. Free shipping over $50." },
];

export default function HowItWorks() {
  return (
    <PageShell kicker="How It Works" title="From idea to doorstep" subtitle="Ordering custom apparel shouldn't be complicated. Here's exactly how our process works.">
      <section className="max-w-4xl mx-auto px-5 lg:px-8 py-16">
        <ol className="space-y-6">
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <li key={s.title} className="bg-white rounded-2xl border border-[color:var(--dms-navy)]/10 p-6 md:p-8 flex gap-6 items-start hover-lift">
                <div className="w-14 h-14 rounded-full bg-[color:var(--dms-peach)] flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-[color:var(--dms-navy)]" />
                </div>
                <div>
                  <h3 className="font-serif text-2xl text-[color:var(--dms-navy)]">{s.title}</h3>
                  <p className="mt-2 text-[color:var(--dms-navy)]/70">{s.desc}</p>
                </div>
              </li>
            );
          })}
        </ol>
        <div className="text-center mt-12">
          <Link to="/custom-design" className="btn-peach">Start my custom design <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </section>
    </PageShell>
  );
}
